import React, { useEffect, useState, useRef } from 'react';
import { ApiCore } from '../../api';
import styles from './paySheetDetail.module.scss';
import { Toast } from 'antd-mobile';
import utils from '../../utils/utils';
const api = new ApiCore();

function PaySheetDetail(props: any) {

    const [item, setItem] = useState({
        title: '',
        userName: '',
        balanceNum: '',
        createTime: '',
        amount: '',
        openBank: '',
        bankNo: ''
    });
    const [duringTime, setDuringTime] = useState('');

    useEffect(() => {
        document.title = '结算单详情';
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        const itemDetail = sessionStorage.getItem('doctor_pay_sheet_item') || '';
        let detailInfo = JSON.parse(itemDetail);
        api.getPaySheetDetail(detailInfo.id).then((res: any) => {
            if (res.code == 0) {
                setItem(res.data);
                let _data = res.data;
                let beginTime = _data.balanceBegin ? _data.balanceBegin.replace('T', ' ') : '';
                let endTime = _data.balanceEnd ? _data.balanceEnd.replace('T', ' ') : '';
                let duringTime = beginTime + ' 至 ' + endTime;
                setDuringTime(duringTime);
            }
        });
        let _urlParam = utils.getUrlParams() || {};
        let _needView: any = _urlParam.needView;
        if (_needView && detailInfo.id) {
            // 完成阅读
            api.toUserSettlementRead({
                id: detailInfo.id
            });
        }
    }

    return (
        <div className={styles.paySheetDetail_content}>
            <div className={styles.title}>
                {item.title}
            </div>
            <div>
                <div className={styles.item}>
                    <div className={styles.item_left}>姓名</div>
                    <div className={styles.item_right}>{item.userName}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.item_left}>发放时间</div>
                    <div className={styles.item_right}>{item.createTime ? item.createTime.replace('T', ' ') : ''}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.item_left}>结算周期</div>
                    <div className={styles.item_right}>{duringTime}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.item_left}>合格例数</div>
                    <div className={styles.item_right}>{item.balanceNum}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.item_left}>收款账号</div>
                    <div className={styles.item_right}>{item.bankNo}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.item_left}>收款行</div>
                    <div className={styles.item_right}>{item.openBank}</div>
                </div>
                <div className={styles.item}>
                    <div className={styles.item_left}>实发金额</div>
                    <div className={styles.item_right_money}>{item.amount}</div>
                </div>
            </div>
        </div>
    )
}

export default PaySheetDetail;